import { CheckCircleFilled, CloseCircleFilled, CloseOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import { Col, Row, Typography } from "antd";
import React from "react";

const { Text, Title } = Typography;

interface LimitStateProps{
    tripped: boolean | null | undefined;
    title: string;
    subTitle?: string | null;
}

const LimitState : React.FC<LimitStateProps> = ({ tripped, title, subTitle }) => {

    return(
        <Row 
        justify='center' 
        align='middle' 
        style={{ 
            backgroundColor: tripped == null ? 'rgba(139, 136, 136, 0.1)' : tripped ? 'rgba(255, 77, 79, 0.1)' : 'rgba(82, 196, 26, 0.1)', 
            display:'flex',  
            position:'relative',
            width: '360px', 
            height: '100px',
            // maxWidth:'350px', 
            borderRadius: '4px', 
            paddingTop:'16px',
            paddingBottom:'16px',
            paddingLeft:'10px',
            paddingRight:'10px', 
            border: tripped == null ? '1px solid gray' : tripped ? '1px solid #ff4d4f' : '1px solid #52c41a'
        }}>
            <Col span={3}>
                {
                    tripped == null ? 
                    <QuestionCircleOutlined 
                    style={{
                        fontSize: '24px',
                        color: 'gray',
                        borderRadius: '50%',
                        padding: '0px'
                    }} 
                    /> :
                    tripped ? 
                    <CloseCircleFilled 
                    style={{
                        fontSize: '24px',
                        color: '#ff4d4f',
                        borderRadius: '50%',
                        padding: '0px'
                    }}/>
                    : 
                    <CheckCircleFilled 
                    style={{
                        fontSize: '24px',
                        color: '#52c41a',
                        borderRadius: '50%',
                        padding: '0px'
                    }}/>

                }

            </Col>
            <Col span={21}>
                <Row>
                    <Text style={{ fontSize:'16px' }} strong>{title}</Text>
                </Row>
                {subTitle &&
                    <Row>
                        <Text style={{  fontSize:'14px', color: 'gray'  }} strong>{subTitle}</Text>
                    </Row>
                }

            </Col>
            {   
                tripped && 
                    <Row 
                    style={{
                        position:'absolute',
                        top: '-10px',
                        right: '-10px',
                        backgroundColor: '#ff4d4f',
                        color: 'white',
                        padding: '2px 8px',
                        borderRadius: '10px',
                        fontSize: '12px',
                        fontWeight: 'bold'
                    }}>
                        <Text style={{ color:'white' }}strong>Tripped</Text>
                    </Row>
            }

        </Row>
    )
}


export default LimitState;